import styles from "./headerv3.module.scss";
import Nav from "./nav-pc";
import { useEffect, useRef, useState } from "react";
import { useWindowSize } from "../../util/functionGlobal";
import Link from "next/link";
import Image from "next/legacy/image";
import moment from "moment";
import classNames from "classnames";

const HeaderPc = (props) => {
  const mainMenuRef = useRef(null);
  const backdropRef = useRef(null);
  const { width } = useWindowSize();
  const [showMenuMobile, setShowMenuMobile] = useState(false);
  const [showBackdropMenu, setShowBackdropMenu] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [dataBlogdNews, setDataBlogdNews] = useState([]);
  const [dataFeaturedNews, setDataFeaturedNews] = useState([]);

  const closeMenu = () => {
    setShowMenuMobile(false);
    setShowBackdropMenu(false);
  };

  const openMenu = () => {
    setShowMenuMobile(true);
    setShowBackdropMenu(true);
  };

  const closeOver = () => {
    setShowMenuMobile(false);
    setShowBackdropMenu(false);
  };

  const toggleCollapse = (id) => {
    setOpenId(openId === id ? null : id);
  };

  const showBackdrop = () => {
  if (!backdropRef.current) {
    backdropRef.current = document.createElement("div");
    backdropRef.current.className = styles["backdropmenu"];
    document.body.appendChild(backdropRef.current);

    // gắn sự kiện click vào backdrop
    backdropRef.current.addEventListener("click", () => {
      // Ẩn toàn bộ submenu
      document.querySelectorAll(`.${styles.show}`).forEach((el) => {
        el.classList.remove(styles.show);
      });
      const header = document.querySelector(`.${styles.header}`);
      if (header) header.classList.remove(styles["color-header"]);
      hideBackdrop();
    });
  }
};

  const hideBackdrop = () => {
    let backdrop = document.querySelector(`.${styles.backdropmenu}`);
    if (backdrop) {
      backdropRef.current.remove();
      backdropRef.current = null;
    }
  };


  useEffect(() => {
    fetch(`/SapoUpdates/SapoUpdateJson.json?Page=1&Category=-1&Tags=&Limit=2`)
      .then((response) => response?.json())
      .then((data) => {
        setDataFeaturedNews(data.ListPost?.length ? data.ListPost : []);
      });
    fetch(`/blog/api/get_feed?limit=3&notIn=27,30,25,31,32,33,34,35,36`)
      .then((response) => response?.json())
      .then((data) => {
        setDataBlogdNews(data.data?.length ? data.data : []);
      });
  }, []);


  function handleMenuClick(e: React.MouseEvent<HTMLLIElement>) {
    const mainMenu = mainMenuRef.current;
    const clickedItem = e.currentTarget;
    const header = document.querySelector(`.${styles.header}`);
    if (!mainMenu || !header) return;

    const isActive = clickedItem.classList.contains(styles.show);

    // Ẩn tất cả submenu khác trước
    mainMenu.querySelectorAll(`.${styles.show}`).forEach((el) => {
      el.classList.remove(styles.show);
    });

    if (isActive) {
      // nếu đang mở rồi thì click lại để đóng
      clickedItem.classList.remove(styles.show);
      header.classList.remove(styles["color-header"]);
      hideBackdrop();
    } else {
      // mở submenu mới
      clickedItem.classList.add(styles.show);
      header.classList.add(styles["color-header"]);
      showBackdrop();
    }
  }

 

  const trialBtn = `<a class="btn-registration" href="#" onclick="Sapo.register.openPopupTrial()">Đăng ký</a>`;
  const trialBtnMobile = `<a class="${styles["btn-registration"]}" href="#" onclick="Sapo.register.openPopupTrial()"> <span class="text">Dùng thử miễn phí</span> <span class="${styles["icon"]}"> <svg><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#IconArrow"></use></svg> </span> </a>`;

  const currentDate = new Date();
  const startDate = new Date("2025-01-12T00:00:00");
  const endDate = new Date("2025-02-09T23:59:59");

  const isTetTime = currentDate > startDate && currentDate < endDate;

  return (
    <>
      <div id="header" className={`${styles["header"]} ${styles.WEB} ${styles["active-child"]}`}>
        <div className={`${styles["main-header"]} d-flex align-items-center flex-wrap`}>
          <div className={styles.container}>
            <div className="row">
              <div className="col-xl-2 col-8 d-flex align-items-center ">
                <Link id="logo" className={`${styles["main-logo"]} d-xl-block d-none`} href="https://www.sapo.vn">
                  <img
                    style={isTetTime ? { height: "43px" } : {}}
                    src={
                      isTetTime
                        ? process.env.NEXT_PUBLIC_BASE_PATH + "/images/logo/Sapo-logo-tet.svg"
                        : process.env.NEXT_PUBLIC_BASE_PATH + "/images/logo/sapo-logo.svg"
                    }
                    className={styles["main-logo"]}
                    alt="Sapo logo"
                  />
                </Link>
                <Link className={`${styles["main-logo"]} d-block d-xl-none`} href="https://www.sapo.vn">
                  <img
                    style={isTetTime ? { height: "43px" } : {}}
                    src={
                      isTetTime
                        ? process.env.NEXT_PUBLIC_BASE_PATH + "/images/logo/Sapo-logo-tet.svg"
                        : process.env.NEXT_PUBLIC_BASE_PATH + "/images/logo/sapo-logo.svg"
                    }
                    className={styles["main-logo"]}
                    alt="Sapo logo"
                  />
                </Link>
              </div>
              <div
                className={`${styles["position-initial"]} col-xl-10 col-4 d-flex justify-content-end justify-space-beetwen-index   align-items-center`}
              >
                <ul
                  className={`${styles["main-menu"]} ${styles["update-menu"]} ${styles["after"]} d-none d-xl-flex align-items-center`}
                  ref={mainMenuRef}
                >
                  <li onClick={handleMenuClick} className={` ${styles["hasChild"]} li`}>
                    <a href="#" onClick={(e) => { e.preventDefault(); }}>
                      Giải pháp <i className="fa fa-angle-down"></i>{" "}
                    </a>
                    <div className={`${styles["sub-menu"]} ${styles["sub-menu-solution"]}`}>
                      <div className={`${styles["grid-template-columns-4"]} ${styles["d-grid"]} ${styles["container"]}`}>
                        <div className={`${styles["item"]}`}>
                          <h3 className="d-flex align-items-center">
                            <svg>
                              <use xlinkHref="#IconSalesChannel"></use>
                            </svg>
                            Bán hàng hợp kênh
                          </h3>
                          <ul>
                            <li>
                              <a href="/phan-mem-quan-ly-ban-hang.html" title="Bán tại cửa hàng">
                                <strong>
                                  Bán tại cửa hàng
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Tính tiền và in hóa đơn nhanh chóng</p>
                              </a>
                            </li>
                            <li>
                              <a href="/phan-mem-quan-ly-san-thuong-mai-dien-tu.html" title="Bán trên sàn TMĐT">
                                <strong>
                                  Bán trên sàn TMĐT
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Tăng doanh thu từ Shopee, TiktokShop, Tiki,...</p>
                              </a>
                            </li>
                            <li>
                              <a href="/phan-mem-quan-ly-ban-hang-fanpage-facebook.html" title="Bán hàng trên MXH">
                                <strong>
                                  Bán hàng trên MXH
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Tăng trưởng bán hàng trên Facebook, Zalo...</p>
                              </a>
                            </li>
                            <li>
                              <a href="/thiet-ke-website-ban-hang.html" title="Bán hàng trên Website">
                                <strong>
                                  Bán hàng trên Website
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Thiết kế website bán hàng chuyên nghiệp</p>
                              </a>
                            </li>
                            <li>
                              <a href="/omnichannel.html" title="Bán hàng hợp kênh">
                                <strong>
                                  Bán hàng hợp kênh
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Bán hợp kênh từ Online đến Offline</p>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className={styles["item"]}>
                          <h3 className="d-flex align-items-center">
                            <svg>
                              <use xlinkHref="#IconManagementChannel"></use>
                            </svg>
                            Quản lý hợp kênh
                          </h3>
                          <ul>
                            <li>
                              <a href="/phan-mem-quan-ly-kho.html" title="Quản lý kho">
                                <strong>
                                  Quản lý kho
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Nắm bắt chính xác lượng hàng trong kho</p>
                              </a>
                            </li>
                            <li>
                              <a href="/cham-soc-khach-hang.html" title="Quản lý khách hàng">
                                <strong>
                                  Quản lý khách hàng
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Lưu thông tin và chăm sóc sau bán</p>
                              </a>
                            </li>
                            <li>
                              <a href="/phan-mem-quan-ly-nhan-vien.html" title="Quản lý nhân viên">
                                <strong>
                                  Quản lý nhân viên
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Phân quyền, theo dõi doanh số nhân viên</p>
                              </a>
                            </li>
                            <li>
                              <a href="/chat-da-kenh.html" title="Chat hợp kênh AI">
                                <strong>
                                  Chat hợp kênh AI
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                  <svg className={styles["iconomniai"]} id="iconomniai"><use xmlnsXlink="http://www.w3.org/1999/xlink" href="#IconOmniAi"></use></svg>
                                </strong>
                                <p>Quản lý hội thoại Facebook, Shopee,...</p>
                              </a>
                            </li>
                            <li>
                              <a href="/omnichannel.html#quan-ly-hop-kenh" title="Quản lý hợp kênh">
                                <strong>
                                  Quản lý hợp kênh
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Quản lý tập trung tất cả các kênh</p>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className={styles["item"]}>
                          <h3 className="d-flex align-items-center">
                            <svg>
                              <use xlinkHref="#IconManagementFood"></use>
                            </svg>
                            Quản lý nhà hàng & dịch vụ
                          </h3>
                          <ul>
                            <li>
                              <a href="/phan-mem-quan-ly-nha-hang.html" title="Quản lý nhà hàng, quán ăn">
                                <strong>
                                  Quản lý nhà hàng, quán ăn
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Tính tiền và quản lý nhà hàng toàn diện</p>
                              </a>
                            </li>
                            <li>
                              <a href="/phan-mem-quan-ly-quan-cafe.html" title="Quản lý quán trà sữa, trà chanh">
                                <strong>
                                  Quản lý quán cafe, tiệm bánh
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Order nhanh, quản lý doanh thu chính xác</p>
                              </a>
                            </li>
                            <li>
                              <a href="/phan-mem-quan-ly-quan-tra-sua.html" title="Quản lý quán trà sữa, trà chanh">
                                <strong>
                                  Quản lý quán trà sữa, trà chanh
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Bán hàng dễ dàng, quản lý topping chi tiết</p>
                              </a>
                            </li>
                            <li>
                              <a href="/phan-mem-quan-ly-quan-bida.html" title="Quản lý quán bida">
                                <strong>
                                  Quản lý quán bida
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Đặt bàn nhanh chóng, quản lý từ xa dễ dàng</p>
                              </a>
                            </li>
                            <li>
                              <a href="/phan-mem-quan-ly-quan-karaoke.html" title="Quản lý quán bar, karaoke">
                                <strong>
                                  Quản lý quán bar, karaoke
                                  <svg>
                                    <use xlinkHref="#IconArrowRight"></use>
                                  </svg>
                                </strong>
                                <p>Thiết lập giá theo giờ, tính tiền linh hoạt</p>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className={`${styles["item"]} ${styles["list-invoive"]}`}>
                          <div className={styles["item-invoive"]} onClick={() => (window.location.href = "/phan-mem-ke-toan.html")}>
                            <div className={styles["title"]}>
                              <a href="/phan-mem-ke-toan.html" title="Phần mềm kế toán cho hộ kinh doanh và doanh nghiệp">
                                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" > <path d="M27.7999 40.1047H8.56063C5.85771 40.1047 3.66699 37.9337 3.66699 35.2552V8.4217C3.66699 5.74319 5.85771 3.57227 8.56063 3.57227H27.9614C30.6644 3.57227 32.8551 5.74319 32.8551 8.4217V17.9023" stroke="#007AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> <path d="M26.1681 10.1997H10.356V18.3702H26.1681V10.1997Z" stroke="#007AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> <path d="M10.356 33.4771H11.5516" stroke="#007AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> <path d="M10.356 26.0396H11.5516" stroke="#007AFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> <path d="M33.9059 25.957L27.5654 32.2403" stroke="#3AE780" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> <ellipse cx="32.9569" cy="34.6726" rx="1.63121" ry="1.61648" fill="#3AE780" /> <ellipse cx="28.5101" cy="23.5261" rx="1.63121" ry="1.61648" fill="#3AE780" /> <path d="M41.1708 33.7279C41.8102 32.3151 42.165 30.7487 42.165 29.0991C42.165 22.8425 37.0462 17.77 30.7326 17.77C24.419 17.77 19.3003 22.8425 19.3003 29.0991C19.3003 35.3557 24.419 40.4282 30.7326 40.4282C32.3965 40.4282 33.9771 40.0758 35.4036 39.4429" stroke="#3AE780" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /> </svg>
                                Phần mềm kế toán cho hộ kinh doanh và doanh nghiệp
                                <div className={styles["tag"]}>NEW</div>
                              </a>
                              <p>
                                Cung cấp đầy đủ các nghiệp vụ theo chế độ kế toán hiện hành, dữ liệu đồng
                                bộ chính xác và minh bạch
                              </p>
                            </div>
                          </div>
                          <div className={`${styles["item-invoive"]} ${styles["pr-0"]}`} onClick={() => (window.location.href = "/sapo-invoice.html")}>
                            <div className={styles["title"]}>
                              <a href="/sapo-invoice.html" title="Phần mềm xuất hóa đơn điện tử từ máy tính tiền">
                              <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"> <path d="M9.53613 34.1185V3.6665H36.8808V34.1185" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M26.2426 12.6777H23.2043C21.5264 12.6777 20.166 14.069 20.166 15.7851C20.166 17.5011 21.5264 18.8924 23.2043 18.8924C24.8822 18.8924 26.2426 20.2837 26.2426 21.9998C26.2426 23.7158 24.8822 25.1071 23.2043 25.1071H20.166" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M23.2085 9.5708V12.6781" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M23.2085 25.1074V28.2148" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M30.8022 40.3333H6.49581C4.81791 40.3333 3.45752 38.942 3.45752 37.226V34.1187H24.7256" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M36.8768 34.1187C36.8768 37.5507 34.156 40.3333 30.8002 40.3333C27.4444 40.3333 24.7236 37.5507 24.7236 34.1187" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>
                              Phần mềm xuất hóa đơn điện tử từ máy tính tiền
                            </a>
                            <p>
                              Đăng ký, phát hành và xử lý hóa đơn điện tử đáp ứng đầy đủ yêu cầu theo quy định của cơ quan Thuế
                            </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles["sapo-ecosystem"]}>
                        <div className={`${styles["container"]} ${styles["d-grid"]} ${styles["grid-template-columns-4"]}`}>
                          <div className={styles.item}>
                            <a href="/sapo-express.html" title="Sapo Express">
                              <strong>
                                Sapo Express{" "}
                                <svg>
                                  <use xlinkHref="#IconArrowRight"></use>
                                </svg>
                              </strong>
                              <p>Giải pháp giảm phí ship và xử lý đơn hàng nhanh hơn 70% cho cửa hàng</p>
                            </a>
                          </div>
                         
                          <div className={styles.item}>
                            <a href="/thanh-toan-khong-tien-mat.html" title="Sapo Pay">
                              <strong>Sapo Pay
                                <svg><use xlinkHref="#IconArrowRight"></use></svg>
                              </strong>
                              <p>
                                Giải pháp thanh toán không tiền mặt dành riêng cho khách hàng Sapo
                              </p>
                            </a>
                          </div>
                          <div className={styles.item}>
                            <a href="/vay-von-kinh-doanh.html" title="Sapo Money">
                              <strong>
                                Sapo Money
                                <svg><use xlinkHref="#IconArrowRight"></use></svg>
                              </strong>
                              <p>
                                Giải pháp vay vốn kinh doanh dành riêng cho khách hàng Sapo
                              </p>
                            </a>
                          </div>
                          <div className={styles.item}>
                            <a href="/sapo-6870.html" title="Sapo 6870">
                              <strong>
                                Sapo 6870
                                <svg>
                                  <use xlinkHref="#IconArrowRight"></use>
                                </svg>
                              </strong>
                              <p>Quản lý bán hàng, hoá đơn điện tử, kê khai – tất cả trong 1 ứng dụng</p>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className={`${styles["bang-gia"]}  no-hasChild li`}>
                    <a href="/bang-gia.html" title="Bảng giá">
                      Bảng giá
                    </a>
                  </li>
                  <li className="no-hasChild li">
                    <a href="/khach-hang.html" title="Khách hàng">
                      Khách hàng
                    </a>
                  </li>
                  <li className={`${styles["nohaschidl"]} li`}>
                    <a href="/enterprise" title="Enterprise">Enterprise</a>
                  </li>
                  <li onClick={handleMenuClick} className={` ${styles["hasChild"]} li`}>
                    <a href="#" onClick={(e) => { e.preventDefault(); }}>
                      Thêm <i className="fa fa-angle-down"></i>{" "}
                    </a>
                    <div className={`${styles["sub-menu"]} ${styles["sapo-new"]}`}>
                      <div className={styles["container"]}>
                        <div className="row">
                          <div className={`${styles["item"]} col-xl-6 col-lg-6`}>
                            <h3 className="d-flex align-items-center">
                              <svg>
                                <use xlinkHref="#IconWhatNew"></use>
                              </svg>
                              Sapo có gì mới
                            </h3>
                            <div className={`${styles["block-blog"]} d-flex`}>
                              <div className={`${styles["item-blog-list"]} ${styles["blog-business-experience-first"]}`}>
                                <div className={`${styles["item-blog"]}`}>
                                  <p className={styles.titleListBlog}>
                                  <a className={styles.texticonright} href="/cap-nhat-tinh-nang.html">
                                    <strong>
                                      Cập nhật tính năng
                                      <svg className={styles.hover}>
                                        <use xlinkHref="#IconArrowRight"></use>
                                      </svg>
                                    </strong>
                                  </a>
                                </p>
                                <ul style={{ width: "100%" }} className={`${styles["blog-business-experience"]} ${styles["blog-business-experience-2"]}`}>
                                  {dataFeaturedNews.map((item, index) => (
                                    <li key={item.id}>
                                      <a href={`${"/cap-nhat-tinh-nang/" + item?.Alias}`} target="_blank" title={item.Title}>
                                        {item.Title}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                                </div>
                                <div className={`${styles["item-blog"]}`}>
                                  <p className={styles.titleListBlog}>
                                  <a className={styles.texticonright} href="https://www.sapo.vn/blog">
                                    <strong>
                                      Blog Sapo
                                      <svg className={styles.hover}>
                                        <use xlinkHref="#IconArrowRight"></use>
                                      </svg>
                                    </strong>
                                  </a>
                                </p>
                                <ul style={{ width: "100%" }} className={`${styles["blog-new-feature"]} ${styles["blog-new-feature-2"]} blog-new-feature-header`}>
                                  {dataBlogdNews.slice(1).map((item, index) => (
                                    <li key={item.id}>
                                      <Link href={`${item?.alias}`} title={item.title}>
                                        {item.title}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                                </div>
                              </div>

                              <div className={`${styles["blog-business-experience-first"]} ${styles["blog-business-experience-first-2"]}`}>
                                <div className={styles["item-blog"]} onClick={() => window.open("https://www.sapo.vn/blog/chuyen-doi-so/tri-tue-nhan-tao-AI", "_blank")}>
                                  <div className={styles["title"]}>
                                    <a href="https://www.sapo.vn/blog/chuyen-doi-so/tri-tue-nhan-tao-AI" title="BÁN HÀNG THÔNG MINH VỚI AI" target="_blank">
                                      <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" href="#IconAi"></use></svg>
                                      BÁN HÀNG THÔNG MINH VỚI AI
                                    </a>
                                  </div>
                                  <p>Tìm hiểu về trí tuệ nhân tạo (AI) và cách ứng dụng hiệu quả trong quản lý bán hàng</p>
                                </div>
                                <div className={styles["item-blog"]} onClick={() => window.open("https://www.sapo.vn/blog/tram-thue-hoa-don", "_blank")}>
                                  <div className={styles["title"]}>
                                    <a href="https://www.sapo.vn/blog/tram-thue-hoa-don" title="TRẠM THUẾ & HÓA ĐƠN" target="_blank">
                                      <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" href="#IconTramthue"></use></svg>
                                      TRẠM THUẾ & HÓA ĐƠN
                                      <div className={styles["record"]} style={{ margin: '-18px 0 0 -3px' }}>
                                        <span className={`${styles.ring} ${styles.ring1}`}></span>
                                        <span className={`${styles.ring} ${styles.ring2}`}></span>
                                        <span className={`${styles.ring} ${styles.ring3}`}></span>
                                        <span className={`${styles.ring} ${styles.ring4}`}></span>
                                      </div>
                                    </a>
                                  </div>
                                  <p>Nơi cập nhật và giải đáp mọi thắc mắc về thuế & hóa đơn điện tử cho hộ kinh doanh - dễ hiểu, dễ áp dụng</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={`${styles["item"]} ${styles["item-blog-list"]} col-xl-3 col-lg-3`}>
                            <h3 className="d-flex align-items-center">
                              <svg>
                                <use xlinkHref="#IconKhamPha"></use>
                              </svg>
                              Khám phá
                            </h3>
                            <div className={styles["itemdiscover"]}>
                              <p className={styles.titleListBlog}>
                                <a href="https://apps.sapo.vn" target="_blank" title="Kho ứng dụng">
                                  <strong>Kho ứng dụng<svg className="hover"><use href="#IconArrowRight"></use></svg></strong>
                                  <span>Khám phá các ứng dụng Sapo với nhiều tính năng thông minh giúp bạn tối ưu quy trình kinh doanh và tăng trưởng bán hàng</span>
                                </a>
                              </p>
                            </div>
                            <div className={styles["itemdiscover"]}>
                              <p className={styles.titleListBlog}>
                                <a href="https://shop.sapo.vn/" target="_blank" title="Thiết bị bán hàng">
                                  <strong>Thiết bị bán hàng<svg className="hover"><use href="#IconArrowRight"></use></svg></strong>
                                  <span>Trọn bộ thiết bị hiện đại, chính hãng và chuyên nghiệp dành riêng cho cửa hàng của bạn</span>
                                </a>
                              </p>
                            </div>

                            <div className={styles["itemdiscover"]}>
                              <p className={styles.titleListBlog}>
                                <a href="/profile-san-pham" target="_blank" title="Sapo Profile">
                                  <strong>Sapo Profile<svg className="hover"><use href="#IconArrowRight"></use></svg></strong>
                                  <span>Tổng quan các dịch vụ Sapo cung cấp cho nhà bán hàng, đáp ứng nhu cầu kinh doanh mọi quy mô và ngành hàng</span>
                                </a>
                              </p>
                            </div>
                          </div>

                          <div className={`${styles["item"]}  ${styles["itemdiscover"]} col-xl-3 col-lg-3`}>
                            <h3 className="d-flex align-items-center">
                              <svg>
                                <use xlinkHref="#IconDocument"></use>
                              </svg>
                              Tài liệu hướng dẫn
                            </h3>
                            <p style={{ marginBottom: "24px" }}><span><a href="https://help.sapo.vn/" target="_blank">Tài liệu, video hướng dẫn sử dụng các dịch vụ Sapo cung cấp</a></span></p>
                            <a
                              style={{ display: "inline-block", marginTop: "10px" }}
                              title="Tài liệu hướng dẫn"
                            >
                              <picture>
                                <source
                                  media="(min-width: 1441px)"
                                  srcSet="https://www.sapo.vn/Themes/Portal/Default/StylesV2/images/home/tai-lieu-huong-dan.png"
                                  className="fade show"
                                />
                                <source
                                  media="(min-width: 1199px)"
                                  srcSet="https://www.sapo.vn/Themes/Portal/Default/StylesV2/images/home/tai-lieu-huong-dan-1366.png"
                                  className="fade show"
                                />
                                <img
                                  src="https://www.sapo.vn/Themes/Portal/Default/StylesV2/images/home/tai-lieu-huong-dan.png"
                                  alt="Tài liệu hướng dẫn sử dụng dịch vụ Sapo"
                                  className="fade show"
                                />
                              </picture>
                            </a>

                          </div>
                        </div>
                      </div>
                      <div className={styles["bottom-sub"]}>
                        <div className={`${styles["container"]} ${styles["d-grid"]} ${styles["grid-template-columns-2"]}`}>
                          <div className={`${styles["item"]}`}>
                            <div className={styles["h3"]}>
                              <a className="d-flex align-items-center" href="/ve-chung-toi.html" title="Về chúng tôi">
                                <svg viewBox="0 0 24 24"><use href="#IconLearnSapo"></use></svg>
                                Về chúng tôi
                                <svg className={styles["hover"]}><use href="#IconArrowRight"></use></svg>
                              </a>
                            </div>
                          </div>
                          <div className={`${styles["item"]}`}>
                            <div className={styles["h3"]}>
                              <a className="d-flex align-items-center" href="https://www.sapo.vn/bao-chi-noi-ve-sapo.html" title="Báo chí nói về Sapo">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M17.843 10.5886V3.75C17.843 2.19656 16.5839 0.9375 15.0305 0.9375H4.64062C3.08719 0.9375 1.82812 2.19656 1.82812 3.75V20.0817C1.82812 21.728 3.17016 23.0625 4.82531 23.0625H19.9861C18.8025 23.0625 17.8425 22.1081 17.8425 20.9311" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M13.9055 4.875H5.76562V8.93906H13.9055V4.875Z" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M5.76562 12.5635H13.9055" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M5.76562 15.9385H13.9055" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M5.76562 19.3135H13.9055" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  <path d="M22.1305 16.2258V9.66138C22.1305 8.10794 20.8714 6.84888 19.318 6.84888H17.8438V20.9254C17.8438 22.1058 18.8009 23.0629 19.9813 23.0629H19.993C21.1733 23.0629 22.1305 22.1058 22.1305 20.9254V20.9137" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Báo chí nói về Sapo
                                <svg className={styles["hover"]}><use href="#IconArrowRight"></use></svg>
                              </a>
                            </div>
                          </div>
                          <div className={`${styles["item"]} ${styles["tuyen-dung"]}`}>
                            <div className={styles["h3"]}>
                              <a className="d-flex align-items-center" href="https://tuyendung.sapo.vn/" title="Tuyển dụng" target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <g clip-path="url(#clip0_18238_3132)">
                                    <path d="M13.6875 8.4375C14.723 8.4375 15.5625 7.59803 15.5625 6.5625C15.5625 5.52697 14.723 4.6875 13.6875 4.6875C12.652 4.6875 11.8125 5.52697 11.8125 6.5625C11.8125 7.59803 12.652 8.4375 13.6875 8.4375Z" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M9.9375 14.0625C9.9375 11.9916 11.6166 10.3125 13.6875 10.3125C15.7584 10.3125 17.4375 11.9916 17.4375 14.0625" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M13.6875 19.6875C18.8652 19.6875 23.0625 15.4902 23.0625 10.3125C23.0625 5.13483 18.8652 0.9375 13.6875 0.9375C8.50983 0.9375 4.3125 5.13483 4.3125 10.3125C4.3125 15.4902 8.50983 19.6875 13.6875 19.6875Z" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M8.51719 18.1342L4.13812 22.5132C3.79875 22.8526 3.33 23.0626 2.8125 23.0626C1.77703 23.0626 0.9375 22.2231 0.9375 21.1876C0.9375 20.6696 1.1475 20.2009 1.48687 19.862L5.86594 15.4829" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_18238_3132">
                                      <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                Tuyển dụng
                                <svg className={styles["hover"]}><use href="#IconArrowRight"></use></svg>
                              </a>
                            </div>
                          </div>

                          <div className={`${styles["item"]} ${styles["thiet-bi-ban-hang"]}`}>
                            <div className={styles["h3"]}>
                              <a className="d-flex align-items-center" href="/lien-he.html" title="Liên hệ">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <g clip-path="url(#clip0_18238_3138)">
                                    <mask id="mask0_18238_3138" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                      <path d="M23.25 0.75V23.25H0.75V0.75H23.25Z" fill="white" stroke="white" strokeWidth="1.5" />
                                    </mask>
                                    <g mask="url(#mask0_18238_3138)">
                                      <path d="M13.4531 6.37476C13.4531 6.40049 13.432 6.42163 13.4062 6.42163C13.3934 6.42163 13.3815 6.41646 13.373 6.40796L13.3594 6.37476C13.3594 6.34902 13.3805 6.32788 13.4062 6.32788L13.4395 6.34155C13.448 6.35005 13.4531 6.36189 13.4531 6.37476Z" fill="#3AE780" stroke="#3AE780" strokeWidth="1.5" />
                                      <path d="M16.2656 6.37476C16.2656 6.40049 16.2445 6.42163 16.2188 6.42163C16.2059 6.42163 16.194 6.41646 16.1855 6.40796L16.1719 6.37476C16.1719 6.34902 16.193 6.32788 16.2188 6.32788L16.252 6.34155C16.2605 6.35005 16.2656 6.36189 16.2656 6.37476Z" fill="#3AE780" stroke="#3AE780" strokeWidth="1.5" />
                                      <path d="M19.0781 6.37476C19.0781 6.40049 19.057 6.42163 19.0312 6.42163C19.0184 6.42163 19.0065 6.41646 18.998 6.40796L18.9844 6.37476C18.9844 6.34902 19.0055 6.32788 19.0312 6.32788L19.0645 6.34155C19.073 6.35005 19.0781 6.36189 19.0781 6.37476Z" fill="#3AE780" stroke="#3AE780" strokeWidth="1.5" />
                                      <path d="M10.885 17.6247L12.9944 16.2185L17.2033 17.6247V20.4372C17.2033 21.2138 16.5838 21.8434 15.8069 21.8434C8.04055 21.8434 0.703125 14.5531 0.703125 6.78678C0.703125 6.01018 1.33277 5.39038 2.10937 5.39038H4.92185L6.3281 9.59927L4.92185 11.7086C5.81974 13.9537 8.63996 16.7268 10.885 17.6247Z" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                      <path d="M9.1875 6.37474C9.1875 8.70453 11.0764 10.5935 13.4062 10.5935V13.406L16.2187 10.5935H19.0312C21.361 10.5935 23.2967 8.70453 23.2967 6.37474C23.2967 4.04494 21.361 2.15601 19.0312 2.15601H13.4062C11.0764 2.15601 9.1875 4.04494 9.1875 6.37474Z" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_18238_3138">
                                      <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                  </defs>
                                </svg>
                                Liên hệ
                                <svg className={styles["hover"]}><use href="#IconArrowRight"></use></svg>
                              </a>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <ul className="d-none d-xl-flex justify-content-end">
                  <li className={`${styles["logins"]} d-flex align-items-center`}>
                    <a href="https://www.sapo.vn/dang-nhap-kenh-ban-hang.html?utm_campaign=cpn:themes-plm:header&utm_source=themes.sapo.vn&utm_medium=referral&utm_content=fm:text_link-km:-sz:&utm_term=&campaign=header_theme_sapo&_gl=1*lgb8ro*_ga*MTY4NzQ3MDk0NS4xNzEzMjYyNzE5*_ga_Y9YZPDEGP0*MTcyMzQ0NzIwMC4yNTAuMS4xNzIzNDQ5OTg3LjUzLjAuMA..*_ga_GECRBQV6JK*MTcyMzQ0NzIwMC4yNTAuMS4xNzIzNDQ5OTg3LjUzLjAuMA..*_ga_YNVPPJ8MZP*MTcyMzQ0NzIwMC4yNTAuMS4xNzIzNDQ5OTg3LjUzLjAuMA..*_ga_CDD1S5P7D4*MTcyMzQ0NzIwMC4yNTAuMS4xNzIzNDQ5OTg3LjUzLjAuMA..*_ga_8956TVT2M3*MTcyMzQ0NzIwMC4yNTAuMS4xNzIzNDQ5OTg4LjUyLjAuMA..">
                      Đăng nhập
                    </a>
                  </li>
                  <li dangerouslySetInnerHTML={{ __html: trialBtn }} className={styles["btn-register"]} />
                </ul>
                <a aria-label="button" href="#" className={`${styles["btn-menu"]} d-inline-block d-xl-none`} onClick={openMenu}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="Capa_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 384 384"
                    xmlSpace="preserve"
                    className={styles["menu-icon"]}
                  >
                    <g>
                      <rect x="0" y="300" width="384" height="50"></rect>
                      <rect x="0" y="150" width="384" height="50"></rect>
                      <rect x="0" y="0" width="384" height="50"></rect>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles["menu-mobile"]}  ${showMenuMobile ? styles["show"] : ""} ${styles.WEB}`}>
        <div className={`${styles["logo-mobile"]}`}>
          <a href="https://www.sapo.vn">
            <img
              style={isTetTime ? { height: "43px" } : {}}
              src={
                isTetTime
                  ? process.env.NEXT_PUBLIC_BASE_PATH + "/images/logo/Sapo-logo-tet.svg"
                  : process.env.NEXT_PUBLIC_BASE_PATH + "/images/logo/sapo-logo.svg"
              }
              className={styles["main-logo"]}
              alt="Sapo logo"
            />
          </a>
          <a href="#" onClick={closeMenu} className={styles["btn-close-menu"]}>
            <svg
              className={styles["icon-close"]}
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 512.001 512.001"
              xmlSpace="preserve"
            >
              <g>
                <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717 L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859 c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287 l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285 L284.286,256.002z"></path>
              </g>
            </svg>
          </a>
        </div>
        <div className={styles["box-scroll"]}>
          <ul className={`${styles["nav"]} ${styles["nav-bottom"]}`} id="accordion">
            <li className={styles["show-sub"]}>
              <a
                data-toggle="collapse"
                onClick={() => toggleCollapse("nav-bottom-child-1")}
                className={`${styles[openId === "nav-bottom-child-1" ? "in" : ""]}`}
                href="#"
                data-target="#nav-bottom-child-1"
              >
                <span>Giải pháp</span>
                <i className="fa fa-angle-down"></i>
              </a>
              <div
                id="nav-bottom-child-1"
                className={`collapse ${openId === "nav-bottom-child-1" ? "show" : ""} ${styles["panel-collapse"]}`}
                data-parent="#accordion"
              >
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg>
                      <use xlinkHref="#IconSalesChannel"></use>
                    </svg>
                    Bán hàng hợp kênh
                  </h3>
                  <ul className={styles["sub-menu"]}>
                    <li>
                      <a href="/phan-mem-quan-ly-ban-hang.html" title="Bán tại cửa hàng">
                        Bán tại cửa hàng
                      </a>
                    </li>
                    <li>
                      <a href="/phan-mem-quan-ly-san-thuong-mai-dien-tu.html" title="Bán trên sàn TMĐT">
                        Bán trên sàn TMĐT
                      </a>
                    </li>
                    <li>
                      <a href="/phan-mem-quan-ly-ban-hang-fanpage-facebook.html" title="Bán hàng trên MXH">
                        Bán hàng trên MXH
                      </a>
                    </li>
                    <li>
                      <a href="/thiet-ke-website-ban-hang.html" title="Bán hàng trên Website">
                        Bán hàng trên Website
                      </a>
                    </li>
                    <li>
                      <a href="/omnichannel.html" title="Bán hàng hợp kênh">
                        Bán hàng hợp kênh
                      </a>
                    </li>
                  </ul>
                </div>

                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg>
                      <use xlinkHref="#IconManagementChannel"></use>
                    </svg>
                    Quản lý hợp kênh
                  </h3>

                  <ul className={styles["sub-menu"]}>
                    <li>
                      <a href="/phan-mem-quan-ly-kho.html" title="Quản lý kho">
                        Quản lý kho
                      </a>
                    </li>
                    <li>
                      <a href="/cham-soc-khach-hang.html" title="Quản lý khách hàng">
                        Quản lý khách hàng
                      </a>
                    </li>
                    <li>
                      <a href="/phan-mem-quan-ly-nhan-vien.html" title="Quản lý nhân viên">
                        Quản lý nhân viên
                      </a>
                    </li>
                    <li>
                      <a href="/chat-da-kenh.html" title="Chat hợp kênh AI">
                        Chat hợp kênh AI
                        <svg className={styles["iconomniai"]} id="iconomniai"><use xmlnsXlink="http://www.w3.org/1999/xlink" href="#IconOmniAi"></use></svg>
                      </a>
                    </li>
                    <li>
                      <a href="/omnichannel.html#quan-ly-hop-kenh " title="Quản lý hợp kênh">
                        Quản lý hợp kênh
                      </a>
                    </li>
                  </ul>
                </div>
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg>
                      <use xlinkHref="#IconManagementFood"></use>
                    </svg>
                    Quản lý nhà hàng & dịch vụ
                  </h3>

                  <ul className={styles["sub-menu"]}>
                    <li>
                      <a href="/phan-mem-quan-ly-nha-hang.html" title="Quản lý nhà hàng, quán ăn">
                        Quản lý nhà hàng, quán ăn
                      </a>
                    </li>
                    <li>
                      <a href="/phan-mem-quan-ly-quan-cafe.html" title="Quản lý quán trà sữa, trà chanh">
                        Quản lý quán cafe, tiệm bánh
                      </a>
                    </li>
                    <li>
                      <a href="/phan-mem-quan-ly-quan-tra-sua.html" title="Quản lý quán trà sữa, trà chanh">
                        Quản lý quán trà sữa, trà chanh
                      </a>
                    </li>
                    <li>
                      <a href="/phan-mem-quan-ly-quan-bida.html" title="Quản lý quán bida">
                        Quản lý quán bida
                      </a>
                    </li>
                    <li>
                      <a href="/phan-mem-quan-ly-quan-karaoke.html" title="Quản lý quán bar, karaoke">
                        Quản lý quán bar, karaoke
                      </a>
                    </li>
                  </ul>
                </div>
                <div className={`${styles["item"]} item-4`}>
                  <ul className={styles["sub-menu"]}>
                    <li>
                      <a href="/sapo-express.html" title="Sapo Express">
                        Sapo Express
                        <p>Giải pháp giảm phí ship và xử lý đơn hàng nhanh hơn 70% cho cửa hàng</p>
                      </a>
                    </li>
                    
                    <li>
                      <a href="/thanh-toan-khong-tien-mat.html" title="Sapo Pay">
                        Sapo Pay
                        <p>Giải pháp thanh toán không tiền mặt dành riêng cho khách hàng Sapo</p>
                      </a>
                    </li>
                    <li>
                      <a href="/vay-von-kinh-doanh.html" title="Sapo Money">
                        Sapo Money
                        <p>
                          Giải pháp vay vốn kinh doanh dành riêng cho khách hàng Sapo
                        </p>
                      </a>
                    </li>
                    <li>
                      <a href="/sapo-6870.html" title="Sapo 6870">
                        Sapo 6870
                        <p>Quản lý bán hàng, hoá đơn điện tử, kê khai – tất cả trong 1 ứng dụng</p>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className={`${styles["item"]} ${styles["list-invoive"]}`}>
                        <div className={styles["item-invoive"]}>
                            <div className={styles["title"]}>
                                <a href="/phan-mem-ke-toan.html" title="Phần mềm kế toán cho hộ kinh doanh và doanh nghiệp">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                        <path d="M27.7999 40.1047H8.56063C5.85771 40.1047 3.66699 37.9337 3.66699 35.2552V8.4217C3.66699 5.74319 5.85771 3.57227 8.56063 3.57227H27.9614C30.6644 3.57227 32.8551 5.74319 32.8551 8.4217V17.9023" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M26.1681 10.1997H10.356V18.3702H26.1681V10.1997Z" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M10.356 33.4771H11.5516" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M10.356 26.0396H11.5516" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M33.9059 25.957L27.5654 32.2403" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <ellipse cx="32.9569" cy="34.6726" rx="1.63121" ry="1.61648" fill="#3AE780"></ellipse>
                                        <ellipse cx="28.5101" cy="23.5261" rx="1.63121" ry="1.61648" fill="#3AE780"></ellipse>
                                        <path d="M41.1708 33.7279C41.8102 32.3151 42.165 30.7487 42.165 29.0991C42.165 22.8425 37.0462 17.77 30.7326 17.77C24.419 17.77 19.3003 22.8425 19.3003 29.0991C19.3003 35.3557 24.419 40.4282 30.7326 40.4282C32.3965 40.4282 33.9771 40.0758 35.4036 39.4429" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    Phần mềm kế toán cho hộ kinh doanh và doanh nghiệp
                                    <div className={styles["tag"]}>NEW</div>
                                </a>
                            </div>
                            <p>Cung cấp đầy đủ các nghiệp vụ theo chế độ kế toán hiện hành, dữ liệu đồng bộ chính xác và minh bạch</p>
                        </div>
                        <div className={styles["item-invoive"]}>
                            <div className={styles["title"]}>
                                <a href="/sapo-invoice.html" title="Phần mềm xuất hóa đơn điện tử từ máy tính tiền">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                                        <path d="M9.53613 34.1185V3.6665H36.8808V34.1185" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M26.2426 12.6777H23.2043C21.5264 12.6777 20.166 14.069 20.166 15.7851C20.166 17.5011 21.5264 18.8924 23.2043 18.8924C24.8822 18.8924 26.2426 20.2837 26.2426 21.9998C26.2426 23.7158 24.8822 25.1071 23.2043 25.1071H20.166" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M23.2085 9.5708V12.6781" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M23.2085 25.1074V28.2148" stroke="#3AE780" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M30.8022 40.3333H6.49581C4.81791 40.3333 3.45752 38.942 3.45752 37.226V34.1187H24.7256" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        <path d="M36.8768 34.1187C36.8768 37.5507 34.156 40.3333 30.8002 40.3333C27.4444 40.3333 24.7236 37.5507 24.7236 34.1187" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                    Phần mềm xuất hóa đơn điện tử từ máy tính tiền
                                </a>
                            </div>
                            <p>Đăng ký, phát hành và xử lý hóa đơn điện tử đáp ứng đầy đủ yêu cầu theo quy định của cơ quan Thuế</p>
                        </div>
                    </div>
              </div>
            </li>
            <li className="bang-gia">
              <a href="/bang-gia.html">Bảng giá</a>
            </li>
            <li>
              <a href="/khach-hang.html">Khách hàng</a>
            </li>
            <li>
              <a href="/enterprise">Enterprise</a>
            </li>
            
            <li className={styles["show-sub"]}>
              <a
                data-toggle="collapse"
                href="#"
                onClick={() => toggleCollapse("nav-bottom-child-3")}
                className={`${styles[openId === "nav-bottom-child-3" ? "in" : ""]}`}
                data-target="#nav-bottom-child-3"
              >
                <span>Thêm</span>
                <i className="fa fa-angle-down"></i>
              </a>
              <div
                id="nav-bottom-child-3"
                className={`collapse ${openId === "nav-bottom-child-3" ? "show" : ""} ${styles["panel-collapse"]}`}
                data-parent="#accordion"
              >
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg>
                      <use xlinkHref="#IconWhatNew"></use>
                    </svg>
                    Sapo có gì mới
                  </h3>
                  <ul className={styles["sub-menu"]}>
                    <li>
                      <a href="/cap-nhat-tinh-nang.html" title="Tính năng mới">
                        Tính năng mới
                      </a>
                    </li>
                    <li>
                      <a href="https://www.sapo.vn/blog" title="Sapo Profile">
                        Blog Sapo
                      </a>
                    </li>
                  </ul>
                </div>

                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg>
                      <use xlinkHref="#IconKhamPha"></use>
                    </svg>
                    Khám phá
                  </h3>
                  <ul className={styles["sub-menu"]}>
                    <li>
                      <a href="https://apps.sapo.vn" target="_blank" title="Kho ứng dụng">
                        Kho ứng dụng
                      </a>
                    </li>
                    <li>
                      <a href="https://shop.sapo.vn/" target="_blank" title="Thiết bị bán hàng">
                        Thiết bị bán hàng
                      </a>
                    </li>
                    <li>
                      <a href="/profile-san-pham" target="_blank" title="Sapo Profile">
                        Sapo Profile
                      </a>
                    </li>
                  </ul>
                </div>
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg>
                      <use xlinkHref="#IconDocument"></use>
                    </svg>
                    Tài liệu hướng dẫn
                  </h3>
                  <ul className={styles["sub-menu"]}>
                    <li>
                      <a href="https://help.sapo.vn/" title="Trợ giúp" target="_blank">
                        Tài liệu, video hướng dẫn sử dụng các dịch vụ Sapo cung cấp
                      </a>
                    </li>
                  </ul>
                </div>
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg>
                      <use xlinkHref="#IconLearnSapo"></use>
                    </svg>
                    Về chúng tôi
                  </h3>
                </div>
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M17.843 10.5886V3.75C17.843 2.19656 16.5839 0.9375 15.0305 0.9375H4.64062C3.08719 0.9375 1.82812 2.19656 1.82812 3.75V20.0817C1.82812 21.728 3.17016 23.0625 4.82531 23.0625H19.9861C18.8025 23.0625 17.8425 22.1081 17.8425 20.9311" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M13.9055 4.875H5.76562V8.93906H13.9055V4.875Z" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M5.76562 12.5635H13.9055" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M5.76562 15.9385H13.9055" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M5.76562 19.3135H13.9055" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M22.1305 16.2258V9.66138C22.1305 8.10794 20.8714 6.84888 19.318 6.84888H17.8438V20.9254C17.8438 22.1058 18.8009 23.0629 19.9813 23.0629H19.993C21.1733 23.0629 22.1305 22.1058 22.1305 20.9254V20.9137" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Báo chí nói về Sapo
                  </h3>
                </div>
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <g clip-path="url(#clip0_18238_3132)">
                        <path d="M13.6875 8.4375C14.723 8.4375 15.5625 7.59803 15.5625 6.5625C15.5625 5.52697 14.723 4.6875 13.6875 4.6875C12.652 4.6875 11.8125 5.52697 11.8125 6.5625C11.8125 7.59803 12.652 8.4375 13.6875 8.4375Z" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.9375 14.0625C9.9375 11.9916 11.6166 10.3125 13.6875 10.3125C15.7584 10.3125 17.4375 11.9916 17.4375 14.0625" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.6875 19.6875C18.8652 19.6875 23.0625 15.4902 23.0625 10.3125C23.0625 5.13483 18.8652 0.9375 13.6875 0.9375C8.50983 0.9375 4.3125 5.13483 4.3125 10.3125C4.3125 15.4902 8.50983 19.6875 13.6875 19.6875Z" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.51719 18.1342L4.13812 22.5132C3.79875 22.8526 3.33 23.0626 2.8125 23.0626C1.77703 23.0626 0.9375 22.2231 0.9375 21.1876C0.9375 20.6696 1.1475 20.2009 1.48687 19.862L5.86594 15.4829" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_18238_3132">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Tuyển dụng
                  </h3>
                </div>
                <div className={styles["item"]}>
                  <h3 className="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <g clip-path="url(#clip0_18238_3138)">
                        <mask id="mask0_18238_3138" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                          <path d="M23.25 0.75V23.25H0.75V0.75H23.25Z" fill="white" stroke="white" strokeWidth="1.5" />
                        </mask>
                        <g mask="url(#mask0_18238_3138)">
                          <path d="M13.4531 6.37476C13.4531 6.40049 13.432 6.42163 13.4062 6.42163C13.3934 6.42163 13.3815 6.41646 13.373 6.40796L13.3594 6.37476C13.3594 6.34902 13.3805 6.32788 13.4062 6.32788L13.4395 6.34155C13.448 6.35005 13.4531 6.36189 13.4531 6.37476Z" fill="#3AE780" stroke="#3AE780" strokeWidth="1.5" />
                          <path d="M16.2656 6.37476C16.2656 6.40049 16.2445 6.42163 16.2188 6.42163C16.2059 6.42163 16.194 6.41646 16.1855 6.40796L16.1719 6.37476C16.1719 6.34902 16.193 6.32788 16.2188 6.32788L16.252 6.34155C16.2605 6.35005 16.2656 6.36189 16.2656 6.37476Z" fill="#3AE780" stroke="#3AE780" strokeWidth="1.5" />
                          <path d="M19.0781 6.37476C19.0781 6.40049 19.057 6.42163 19.0312 6.42163C19.0184 6.42163 19.0065 6.41646 18.998 6.40796L18.9844 6.37476C18.9844 6.34902 19.0055 6.32788 19.0312 6.32788L19.0645 6.34155C19.073 6.35005 19.0781 6.36189 19.0781 6.37476Z" fill="#3AE780" stroke="#3AE780" strokeWidth="1.5" />
                          <path d="M10.885 17.6247L12.9944 16.2185L17.2033 17.6247V20.4372C17.2033 21.2138 16.5838 21.8434 15.8069 21.8434C8.04055 21.8434 0.703125 14.5531 0.703125 6.78678C0.703125 6.01018 1.33277 5.39038 2.10937 5.39038H4.92185L6.3281 9.59927L4.92185 11.7086C5.81974 13.9537 8.63996 16.7268 10.885 17.6247Z" stroke="#007AFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M9.1875 6.37474C9.1875 8.70453 11.0764 10.5935 13.4062 10.5935V13.406L16.2187 10.5935H19.0312C21.361 10.5935 23.2967 8.70453 23.2967 6.37474C23.2967 4.04494 21.361 2.15601 19.0312 2.15601H13.4062C11.0764 2.15601 9.1875 4.04494 9.1875 6.37474Z" stroke="#3AE780" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                      </g>
                      <defs>
                        <clipPath id="clip0_18238_3138">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    Liên hệ
                  </h3>
                </div>
              </div>
            </li>
            <li className={styles.login}>
              <a href="/dang-nhap-kenh-ban-hang.html">Đăng nhập</a>
            </li>
          </ul>
        </div>
        <div className={styles["trial-fixed"]}>
          <div className={styles["btn-register"]} dangerouslySetInnerHTML={{ __html: trialBtnMobile }}></div>
        </div>
      </div>
      <div className={`${styles["overlay-menu"]} ${showBackdropMenu ? styles["show"] : ""}`} onClick={closeOver}></div>
      {props.width > 991 && <Nav />}
    </>
  );
};

export default HeaderPc;
